import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { CacheEnum } from '@/enum/cache';

// 工具类型定义
export type ToolType = 'pricing' | 'more';

export interface Tool {
  key: ToolType;
  label: string;
  icon: string; // Semi Icon 名称
}

// 可用工具列表
export const AVAILABLE_TOOLS: Tool[] = [
  { key: 'pricing', label: '定价计算器', icon: 'calculator' },
  // 后续可扩展更多工具
  // { key: 'more', label: '更多工具', icon: 'plus' },
];

interface ToolboxState {
  // 工具箱是否展开
  isOpen: boolean;
  // 当前选中的工具
  activeTool: ToolType;
  // 是否已看过引导
  hasSeenGuide: boolean;
  // 引导是否被其他弹层抑制（如版本更新通知）
  isGuideSuppressed: boolean;
  // 操作方法
  openToolbox: () => void;
  closeToolbox: () => void;
  toggleToolbox: () => void;
  setActiveTool: (tool: ToolType) => void;
  markGuideSeen: () => void;
  setGuideSuppressed: (suppressed: boolean) => void;
}

const useToolboxStore = create<ToolboxState>()(
  persist(
    (set) => ({
      isOpen: false,
      activeTool: 'pricing',
      hasSeenGuide: false,
      isGuideSuppressed: false,

      openToolbox: () => set({ isOpen: true }),
      closeToolbox: () => set({ isOpen: false }),
      toggleToolbox: () => set((state) => ({ isOpen: !state.isOpen })),
      setActiveTool: (tool) => set({ activeTool: tool }),
      markGuideSeen: () => set({ hasSeenGuide: true }),
      setGuideSuppressed: (suppressed) =>
        set({ isGuideSuppressed: suppressed }),
    }),
    {
      name: CacheEnum.toolboxStorage,
      // 持久化 activeTool 和 hasSeenGuide
      partialize: (state) => ({
        activeTool: state.activeTool,
        hasSeenGuide: state.hasSeenGuide,
      }),
    }
  )
);

export default useToolboxStore;
